import React from 'react'
import { existingCharacters } from '../../../ShotList/helper/data.character'
import { Tabs, Select, Button, Upload, Card } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import CommentInput from '../../../CommentInput'

const { Option } = Select
const { TabPane } = Tabs

const AdvancedSettingsContent = ({
  settings,
  updateSettings,
  saveSettings,
  handleUploadImage,
  formData,
  onCancel
}) => {
  return (
    <div className="advanced-settings-drawer-content">
      <Tabs defaultActiveKey="1">
        {/* <TabPane tab="Character" key="1">
          <Card bordered={true} style={{ marginBottom: '16px' }}>
            <div className="setting-group">
              <label>Select Character</label>
              <Select
                value={settings.characterId}
                onChange={value => updateSettings('characterId', value)}
                style={{ width: '100%' }}
              >
                {formData.characterList.map((character, characterIndex) => (
                  <Select.Option key={characterIndex} value={characterIndex}>
                    {character && character.name}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Card>
        </TabPane> */}
        {/* <TabPane tab="Shot Style" key="2">
          <Card bordered={true} style={{ marginBottom: '16px' }}>
            <div className="setting-group">
              <label>Shot Type</label>
              <Select
                value={settings.shotType}
                onChange={value => updateSettings('shotType', value)}
                style={{ width: '100%' }}
              >
                <Select.Option value="Close-up">Close-up</Select.Option>
                <Select.Option value="Medium Shot">Medium Shot</Select.Option>
                <Select.Option value="Long Shot">Long Shot</Select.Option>
                <Select.Option value="Over the Shoulder">
                  Over the Shoulder
                </Select.Option>
                <Select.Option value="Point of View">
                  Point of View
                </Select.Option>
                <Select.Option value="Aerial Shot">Aerial Shot</Select.Option>
                <Select.Option value="Low Angle">Low Angle</Select.Option>
                <Select.Option value="High Angle">High Angle</Select.Option>
              </Select>
            </div>
          </Card>
        </TabPane> */}
        <TabPane tab="Image" key="3">
          <Card bordered={true} style={{ marginBottom: '16px' }}>
            <div className="setting-group" style={{ alignItems: 'center' }}>
              <label>Reference Image</label>
              <div
                className="image-preview-container"
                style={{ marginBottom: '16px' }}
              >
                {settings.imageSrc && (
                  <img
                    src={settings.imageSrc}
                    alt="Reference"
                    style={{
                      maxWidth: '100%',
                      maxHeight: '200px',
                      marginBottom: '10px'
                    }}
                  />
                )}
              </div>
              <Upload
                name="imageFile"
                listType="picture"
                showUploadList={false}
                beforeUpload={handleUploadImage}
              >
                <Button icon={<UploadOutlined />}>
                  {settings.imageSrc ? 'Change Image' : 'Upload Image'}
                </Button>
              </Upload>
            </div>
          </Card>
        </TabPane>
        <TabPane tab="Prompt" key="4">
          <Card bordered={true} style={{ marginBottom: '16px' }}>
            <div className="setting-group">
              <CommentInput
                characters={formData.characterList}
                text={settings.shot_direction}
                placeholder="Write your video prompt..."
              />
            </div>
          </Card>
        </TabPane>
      </Tabs>

      <div
        className="drawer-footer"
        style={{ marginTop: '20px', textAlign: 'right' }}
      >
        <Button onClick={onCancel} style={{ marginRight: '8px' }}>
          Cancel
        </Button>
        <Button type="primary" onClick={saveSettings}>
          Save Advanced Settings
        </Button>
      </div>
    </div>
  )
}

export default AdvancedSettingsContent
